<template>
    <div class="grid" ref="template">
        <div class="grid-full cogi-subtitle">
            <cogi-label-only label="Territoires" />
        </div>

        <a class="grid-full-margin" target="_blank" :href="urlDocumentTerritoires" v-if="aUrlDocumentTerritoires">
            <cogi-image :image="imageTerritoire" />
        </a>
        <cogi-image v-else :image="imageTerritoire" class="grid-full-margin" />

        <cogi-checkboxgroup
            :culture="model.culture!"
            cssClass="grid-full"
            :required="true"
            @validated="validated"
            :valideNow="valideNow"
            v-model="model.territoiresSelectionnes"
            label="SelectionnezUnOuPlusieursTerritoires"
            :sourceItems="sourceItemsTerritoire"
            :codeVisible="true"
            :tousVisible="true"
            :nbColonnesAffichage="3"></cogi-checkboxgroup>

        <div class="grid-full cogi-subtitle" v-show="utiliseAuMoinsUnModeleHabitation">{{ i18n.t('ChoixDeModelesDhabitation') }}</div>
        <cogi-modelehabitation
            :culture="model.culture"
            :visible="utiliseAuMoinsUnModeleHabitation!"
            cssClass="grid-full"
            :required="true"
            @validated="validated"
            :valideNow="valideNow"
            v-model="model"
            :sourceItemsResponsabiliteCoop="sourceItemsResponsabiliteCoop"
            :sourceItemsImplicationOrganisme="sourceItemsImplicationOrganisme"
            :sourceItemsServiceDesires="sourceItemsServiceDesires"></cogi-modelehabitation>

        <cogi-button cssClass="gridspan15 right" cssClassButton="precedent" text="EtapePrecedente" @click="precedent"></cogi-button>
        <cogi-button cssClass="gridspan1 right" cssClassButton="suivant" text="EtapeSuivante" @click="suivant"></cogi-button>
    </div>
</template>
<script setup lang="ts">
    import { ref, computed, getCurrentInstance } from 'vue'
    import { ValidatorAccumulatorVueComponent, ValidatorAccumulator, ValidationStatutPoco } from './helpers/validatorAccumulator'
    import type { del } from '../../../clients/delclient'

    import CogiLabelOnly from './CogiLabelOnly.vue'
    import CogiButton from './CogiButton.vue'
    import CogiCheckboxgroup from './CogiCheckboxgroup.vue'
    import CogiImage from './CogiImage.vue'
    import CogiModelehabitation from './CogiModelehabitation.vue'
    import type DemandeEnLigneVM from '../DemandeEnLigneVM'
    import { useI18n } from 'vue-i18n'
    const i18n = useI18n()

    interface IPropsCogiEtape4 {
        sourceItemsTerritoire: del.ListItem[]
        sourceItemsImplicationOrganisme: del.ListItem[]
        sourceItemsServiceDesires: del.ListItem[]
        sourceItemsResponsabiliteCoop: del.ListItem[]
    }

    defineProps<IPropsCogiEtape4>()
    const model = defineModel<DemandeEnLigneVM>({ required: true })

    const validatorAccumulator = ref(new ValidatorAccumulatorVueComponent(new ValidatorAccumulator()))
    const hasError = ref(false)
    const valideNow = ref(false)
    const isInsuivantMode = ref(false)
    const validateCallback = ref(defaultValidateCallback)

    const emit = defineEmits<{
        avancerUnEtape: [number]
        reculerUnEtape: [number]
    }>()

    const aUrlDocumentTerritoires = computed(() => {
        return model.value.dicUrlDocumentTerritoires!['fr']
    })

    const utiliseAuMoinsUnModeleHabitation = computed(() => {
        return model.value.utiliseProgrammeHlm || model.value.utiliseProgrammeCoop || model.value.utiliseProgrammeObnl
    })

    const urlDocumentTerritoires = computed(() => {
        return model.value.dicUrlDocumentTerritoires!['fr']
    })

    const imageTerritoire = computed(() => {
        return model.value.dicImageTerritoire![model.value.culture!]
    })

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function defaultValidateCallback(newVal: boolean) {}

    function validated(newValue: boolean) {
        let validationStatut: ValidationStatutPoco = validatorAccumulator.value.validated(newValue)

        if (!validationStatut.validationCompleted) return

        hasError.value = validationStatut.hasError
        valideNow.value = false

        doSuivant()
        validateCallback.value(hasError.value)
        validateCallback.value = defaultValidateCallback
    }

    function suivant() {
        isInsuivantMode.value = true
        validate()
    }

    function doSuivant() {
        if (!isInsuivantMode.value) return

        isInsuivantMode.value = false
        if (hasError.value) return
        else {
            emit('avancerUnEtape', 3)
        }
    }

    function precedent() {
        emit('reculerUnEtape', 3)
    }

    const instance = getCurrentInstance()
    function validate() {
        hasError.value = false
        valideNow.value = validatorAccumulator.value.startValidation(instance)
    }

    defineExpose({ validate, hasError, validateCallback })
</script>
